const toJSON = (r) => r.json().catch(() => ({}));

export const authClient = {
  async login(login, password, signal) {
    const res = await fetch(
      'https://nmt.loveworldapis.com/api/pcdl/auth/login',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'x-api-key': 'ee115610-738b-4e7b-97e2-446468ba550c',
        },
        body: JSON.stringify({ user: { login, password } }),
        signal,
      },
    );

    const data = await toJSON(res);

    // success: matches your sample
    if (res.ok && data.status && data.data.token) {
      // data.body contains: email, token, first_name, etc. + library
      return {
        ok: true,
        user: data.data,
        message: data.message || 'Login Successfully',
      };
    }

    // legacy error handling you mentioned
    if (!data.status) {
      const msg = String(data?.message || '').toLowerCase();

      // Known backend messages → user-friendly copies
      const MESSAGE_MAP = [
        {
          test: (m) => m.includes('password is incorrect'),
          copy: 'Incorrect password. Please try again, or reset your password if you’ve forgotten it.',
        },
        {
          test: (m) => m.includes('email not in database'),
          copy: 'We couldn’t find an account with that email. Emails are case-sensitive—make sure it matches exactly, and check for typos or extra spaces.',
        },
        // Optional extras if your backend sometimes sends them:
        {
          test: (m) => m.includes('too many attempts') || m.includes('account locked'),
          copy: 'Too many sign-in attempts. Please wait a few minutes and try again, or reset your password.',
        },
        {
          test: (m) => m.includes('user not verified') || m.includes('email not verified'),
          copy: 'Your email isn’t verified yet. Please check your inbox for the verification link, then try again.',
        },
        {
          test: (m) => m.includes('account disabled'),
          copy: 'This account is disabled. Please contact support if you think this is a mistake.',
        },
      ];

      const match = MESSAGE_MAP.find((r) => r.test(msg));
      return {
        ok: false,
        error: match
          ? match.copy
          : 'Sign-in failed. Double-check your email/username and password then try again.',
      };
    }

    if (data?.errorType === 'SSLError') return { ok: false, error: 'This Email does not exist.' };

    return {
      ok: false,
      error: data?.message || `Login failed (${res.status}).`,
    };
  },
};
